const callbackRouterPaths = {
  root: '/callback',
  stripe: '/callback/stripe',
};

export default callbackRouterPaths;
